var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","padding-top":"70px","padding-left":"300px","padding-right":"0px","padding-bottom":"70px"}},[_c('v-container',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }